import styled from 'styled-components';
import BaseButton from 'components/Button';

export const Text = styled.p`
  margin-bottom: 50px;
`;

export const Button = styled(BaseButton)`
  margin-left: auto;
  margin-right: auto;
  display: block;
  text-transform: capitalize;
`;

export const FailedNotificationText = styled.p`
  color: #808080;
  text-align: center;
`;

export const reactModalStyle = {
  content: {
    padding: 0,
    top: '30%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    position: 'absolute',
  },
};
